import ReactDOM from 'react-dom';
import 'core-js';
import getdataprops from './hooks/useDataProps';
import App from './App';
import WebComponentPoral from './resources/WebComponentPortal';

const root = document?.getElementById('tjt-podlet-create-offer-button');

if (root) {
    const props = getdataprops();

    ReactDOM.render(
        <WebComponentPoral containerElement={root}>
            <link href={props?.stylelink} media="all" type="text/css" rel="stylesheet" />

            <App />
        </WebComponentPoral>,

        root,
    );
}
